import React, { useMemo, useRef } from "react";
// import MaterialTable from "material-table";
import MaterialTable from "@material-table/core";
// import ExportCsv from "@material-table/exporters/csv";
// import ExportPdf from "@material-table/exporters/pdf";
// import { ExportCsv, ExportPdf } from "@material-table/exporters";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CustomButton from "../CustomButton";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import editIconWhite from "../../../assets/icon/pencil-fill-white.svg";
import deletIcon from "../../../assets/icon/trash-solid.svg";
import deletIconWhite from "../../../assets/icon/trash-solid-white.svg";
import { useLocation } from "react-router-dom";
import Fontstyling from "../comman";
import { downloadCsv } from "../../../Utils/exportCsv";

const CustomMaterialTable = ({
  page,
  title,
  isExport,
  isDelete,
  isEdit,
  column :  baseColumns,
  data,
  data1,
  selectedRow,
  setSelectedRow,
  setWitchAction,
  setSelectedRowData,
  setShowModal,
  isLoading,
  overrideColumn,
  isSearchRequired
}) => {
  const location = useLocation();
  const tableRef = useRef();
  // console.log({ data });

  const defaultCell = useMemo(
    () => ({
      padding: "10px 12px",
      whiteSpace: "nowrap",
      border: "1px solid #dee2e6",
      boxSizing: "border-box",
    }),
    []
  );

  const defaultHeader = useMemo(
    () => ({
      padding: "7px 12px",
      border: "1px solid #dee2e6",
      boxSizing: "border-box",
      backgroundColor: "#18252D",
      color: "#EEF0E2",
      textTransform: "capitalize",
      fontSize: "11px",
      fontFamily: "Arial",
      fontWeight: 700,
    }),
    []
  );

  const withDefaults = (cols = []) =>
    cols.map((c) => ({
      ...c,
      sorting: false,
      cellStyle: { ...defaultCell, ...(c.cellStyle || {}) },
      headerStyle: { ...defaultHeader, ...(c.headerStyle || {}) },
    }));


  const fileName =
    location.pathname.split("/")[location.pathname.split("/").length - 1] +
    "_" +
    (parseInt(new Date().getMonth()) + 1) +
    "_" +
    new Date().getDate() +
    "_" +
    new Date().getFullYear() +
    "_" +
    new Date().getHours() +
    "_" +
    new Date().getMinutes() +
    "_" +
    new Date().getSeconds();

  const ExportButton = isExport ?? true;
 
  const columns = useMemo(()=>{
    if(overrideColumn) return withDefaults(overrideColumn);

    const normalized = withDefaults(baseColumns || []);

    return [
      ...(normalized || []),
        {
      title: "Actions",
      field: "__actions__",
      sorting: false,
      width: 75,
    cellStyle: {
      textAlign: "center",
      padding: "2px 6px",
      width:75,
      minWidth: 74,
      maxWidth: 75,
      whiteSpace: "nowrap",
    },
    headerStyle: {
      textAlign: "center",
      padding: "4px 6px",
      width:75,
      minWidth: 74,
      maxWidth: 75,
      whiteSpace: "nowrap",
    },
      render: (rowData) => (
        <>
          {isEdit !== false ||
          ((location.pathname === "/Admin/clinicalintakerequest" || location.pathname === "/Admin/MarketScanManagement")  &&
            rowData.ApprovedSatus === 0) ? (
            <img
              src={
                selectedRow === rowData.tableData.id ? editIconWhite : editIcon
              }
              width="11"
              className="m-2 cursor-pointer"
              alt="edit icon"
              onClick={() => {
                setWitchAction("update");
                setSelectedRowData(rowData);
                setShowModal(true);
              }}
            />
          ) : (
            <div
              className="m-2"
              style={{ height: "11px", width: "11px" }}
            ></div>
          )}
          {isDelete !== false && (
            <img
              src={
                selectedRow === rowData.tableData.id
                  ? deletIconWhite
                  : deletIcon
              }
              width="11"
              className="m-2 cursor-pointer"
              alt="delete icon"
              onClick={() => {
                setWitchAction("delete");
                setSelectedRowData(rowData);
                setShowModal(true);
              }}
            />
          )}
        </>
      ),
    },
    ]
  },[
    overrideColumn,
    baseColumns,
    isEdit,
    isDelete,
    location.pathname,
    selectedRow,
    setSelectedRowData,
    setShowModal,
    setWitchAction,
  ])
  
  return (
    <MaterialTable
      tableRef={tableRef}
      columns={columns}
      style={{ boxShadow: "none", borderLeft: 0, borderRight: 0 }}
      title={
        <div
          className="p-0 text-nowrap text-truncate"
          style={Fontstyling.modalHeading}
        >
          {title}
        </div>
      }
      data={data}
      isLoading={isLoading}
      icons={{
        Export: () =>
          ExportButton &&
          data.length > 0 && (
            <CustomButton className="text-nowrap d-flex align-items-center">
              <SaveAltIcon className="me-2" />
              Export to CSV
            </CustomButton>
          ),
      }}
      onRowClick={(event, rowData) => {
        if (rowData.tableData.id === selectedRow) setSelectedRow(null);
        else setSelectedRow(rowData.tableData.id);
      }}
      options={{
        exportAllData:
          tableRef?.current?.dataManager?.searchText?.length > 0 ? false : true,
        sorting: false,
        draggable: false,
        actionsColumnIndex: -1,
        paging:
          location.pathname.includes("gdormasterdetail") ||
          location.pathname.includes("SBARIntakeRequest") ||
          location.pathname.includes("geo") ||
          location.pathname.includes("ClientRxInformationBaseline") ||
          location.pathname.includes("RFP") ||
          location.pathname.includes("SDL") ||
          location.pathname.includes("census") ||
          location.pathname.endsWith("/EmpoweRx")
            ? true
            : data.length > 10,
        pageSize: 10,
        pageSizeOptions:
          location.pathname.includes("gdormasterdetail") ||
          location.pathname.includes("geo") ||
          location.pathname.includes("ClientRxInformationBaseline") ||
          location.pathname.includes("RFP") ||
          location.pathname.includes("SBARIntakeRequest") ||
          location.pathname.includes("census") ||
          location.pathname.endsWith("/EmpoweRx")
            ? true
            : data.length > 10,
        paginationType: "normal",
        search: isSearchRequired === "No" ? false : true,
        filtering: false,
        showTitle: title ? true : false,
        toolbar: true,
        toolbarButtonAlignment: "left",
        exportButton: {
          csv: true,
          //  pdf:true
        },
        // exportButton: true,
        exportFileName: fileName,

        // exportCsv: (data, columns) => ExportCsv(columns, data, fileName),
        // exportPdf: (data, columns) =>  ExportPdf(columns, data, fileName),
        exportMenu: [
          // {
          //   label: "Export PDF",
          //   exportFunc: (cols, datas) =>{
          //
          //     ExportPdf(cols, datas, fileName)
          //   }
          // },
          {
            label: "Export CSV",
            exportFunc: (cols, datas) => {
              // console.log({ datas });
              //ExportCsv(cols, datas, fileName);
              downloadCsv(cols, datas, fileName);
            },
          },
        ],
        
        rowStyle: (rowData) => {
          const index = rowData.tableData.id;

          if (index === selectedRow) {
            return {
              padding: "0px",
              fontSize: "11px",
              fontFamily: "Arial",
              border: "1px solid #dee2e6",
              textAlign: "start",
              color: "white",
              backgroundColor: "#999999",
            };
          }
          return {
            padding: "0px",
            fontSize: "11px",
            fontFamily: "Arial",
            border: "1px solid #dee2e6",
            textAlign: "start",
          };
        },
        cellStyle: {
          textAlign: "left",
        },
        headerStyle: {
          padding: "0px",
          zIndex: 0,
          backgroundColor: "#18252D",
          color: "#EEF0E2",
          textTransform: "capitalize",
          fontSize: "11px",
          fontFamily: "Arial",
          fontWeight: "700",
          border: "1px solid #dee2e6",
          borderRight:
            page === "Ranked" || "grouplist"
              ? "2px solid #dee2e6"
              : "1px solid #dee2e6",
          borderLeft:
            page === "Ranked" || "grouplist"
              ? "2px solid #dee2e6"
              : "1px solid #dee2e6",
        },
        actionsCellStyle: {
          padding: "0px",
          maxWidth: "20px",
        },
      }}
    />
  );
};

export default CustomMaterialTable;
